<template>
  <section class="">
    <v-card flat class="pa-0 ma-0">
      <v-row class="mt-3 ms-2">
        <v-col cols="12" lg="4" xs="12">
          <v-combobox
            clearable
            class="rounded mx-1"
            outlined
            dense
            item-text="txt"
            item-value="val"
            placeholder="Deposit Channel"
            v-model="selectedChannel"
            :items="channel_options"
          >
          </v-combobox>
        </v-col>

        <v-col cols="12" lg="2" xs="12">
          <v-btn
            depressed
            color="primary"
            class="mt-1 text-capitalize"
            small
            :disabled="!selectedChannel"
            @click="save()"
          >
            <v-icon small class="me-2">mdi-content-save-check-outline</v-icon>
            Save</v-btn
          >
        </v-col>

        <v-spacer></v-spacer>
        <v-btn depressed @click="downloadExcelsheet" color="primary" small
          ><v-icon small>mdi-file-excel-outline</v-icon>Export
        </v-btn>
        <v-col cols="12" lg="4" xs="12">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Type here to filter the table data."
            single-line
            class="me-4 mx-2"
            dense
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
      <v-card-text>
        <v-data-table
          fixed-header
          height="55vh"
          :headers="headers"
          dense
          :search="search"
          class="mt-2"
          :items="DepositeChannel"
        >
          <template v-slot:item.actions="{ item }">
            <div class="d-flex">
              <v-switch
                v-model="item.is_active"
                height="0px"
                color="success"
                @change="isactiveupdate(item)"
                dense
              ></v-switch>
              <!-- <v-icon small color="primary" class="mr-2">
              mdi-content-save-edit-outline
            </v-icon> -->
              <v-icon small color="primary" @click="deleteItem(item)">
                mdi-trash-can-outline
              </v-icon>
            </div>
          </template>
        </v-data-table>
        <!-- delete dialog -->
        <v-dialog persistent v-model="dialogDelete" width="500">
          <v-card>
            <v-card-title class="border border-bottom">Delete</v-card-title>
            <v-card-text class="h5 py-3"
              >Are you sure you want to Delete?</v-card-text
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                depressed
                small
                color="primary"
                outlined
                @click="deleteItemConfirm"
              >
                <v-icon>mdi-check</v-icon>
              </v-btn>
              <v-btn
                depressed
                small
                color="primary"
                outlined
                @click="closeDelete"
                ><v-icon>mdi-close</v-icon></v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-text>

      <span v-if="this.getCompanyDetails && this.getCompanyDetails.created_by">
        <v-row class="ms-5 mt-3 labelFontsize">
          <v-col cols="12" md="4"
            >Created By :{{
              this.getCompanyDetails && this.getCompanyDetails.created_by
                ? this.getCompanyDetails.created_by
                : null
            }}</v-col
          >
          <v-col cols="12" md="4"
            >Created Date :{{
              this.getCompanyDetails && this.getCompanyDetails.created_date
                ? this.getCompanyDetails.created_date
                : null
            }}</v-col
          >
        </v-row>
        <v-row class="ms-5 mt-3 labelFontsize">
          <v-col cols="12" md="4"
            >Updated By :{{
              this.getCompanyDetails && this.getCompanyDetails.modified_by
                ? this.getCompanyDetails.modified_by
                : null
            }}</v-col
          >
          <v-col cols="12" md="4"
            >Updated Date :{{
              this.getCompanyDetails && this.getCompanyDetails.modified_date
                ? this.getCompanyDetails.modified_date
                : null
            }}</v-col
          >
        </v-row>

        <v-row class="ms-5 mt-3 labelFontsize">
          <v-col cols="12" md="4"
            >Approved By :{{
              this.getCompanyDetails && this.getCompanyDetails.approved_by
                ? this.getCompanyDetails.approved_by
                : null
            }}</v-col
          >
          <v-col cols="12" md="4"
            >Approved Date :{{
              this.getCompanyDetails && this.getCompanyDetails.approved_date
                ? this.getCompanyDetails.approved_date
                : null
            }}</v-col
          >
        </v-row>
      </span>
      <v-divider class="mb-0 pa-0"></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- <v-btn depressed  color="primary" depressed small> Save </v-btn> -->
      </v-card-actions>
    </v-card>
    <loading :active="loader" :opacity="0.9" color="#ff6b00" />
  </section>
</template>

<script>
import partnerService from "@/services/partnerService/partnerService.js";
import setupService from "@/services/SetupService/setupService";
import alerts from "@/mixins/alerts";
import Loading from "vue-loading-overlay";
export default {
  name: "Deposite Channel",
  mixins: [alerts],
  components: {
    Loading,
  },

  data() {
    return {
      search: "",
      loader: false,
      dialogDelete: false,
      itemToDeleteIndex: null,
      selectedChannel: null,
      channel_options: [],
      headers: [
        {
          text: "Id",
          value: "id",
          sortable: false,
        },
        { text: "Channel Name", value: "name", sortable: false },
        // { text: "External Link", value: "external_id", sortable: false },
        { text: "Mapped Ledger ID", value: "ledger_id", sortable: false },
        // { text: "Channel Type", value: "channel_type", sortable: false },
        { text: "Account No", value: "account_number", sortable: false },
        { text: "Account Name", value: "account_name", sortable: false },
        // {
        //   text: "Account Name Other",
        //   value: "account_other_name",
        //   sortable: false,
        // },
        // { text: "Deposit Type", value: "account_type", sortable: false  },
        { text: "Actions", value: "actions", sortable: false },
      ],
      DepositeChannel: [],
      addDepositeChannel: {
        partner_id: this.$route.query.partner_id,
        channel_id: null,
      },
    };
  },
  props: {
    getCompanyDetails: {
      type: Object,
    },
  },
  mounted() {
    this.partnerId = this.$route.query.partner_id;
    console.log("partnerId", this.partnerId);
    const country = localStorage.getItem("companyCountryCode");
    this.getAllChannels();
    this.getChannelsByCountry(country);
  },

  methods: {
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },

    async downloadExcelsheet() {
      if (this.DepositeChannel) {
        this.exportToExcel(
          this.headers,
          this.DepositeChannel,
          "DepositeChannel",
        );
      }
    },

    async getAllChannels() {
      this.loader = true;
      try {
        const responseData = await partnerService.getAllDepositeChannels(
          this.partnerId,
        );
        if (responseData && responseData.data.status_code == 200) {
          this.DepositeChannel = responseData.data.data.reverse();
          this.stoploader();
        } else {
          this.showAlertError("Failed : " + responseData.data.message);
          this.loader = false;
        }
        console.log("DepositeChannel", this.DepositeChannel);
      } catch (e) {
        console.log(e);
        this.loader = false;
      }
    },
    async getPaymentModeById(id) {
      this.loader = true;
      try {
        const responseData = await partnerService.getPaymentById(id);
        if (responseData && responseData.data.status_code == 200) {
          this.paymentModeData = responseData.data.data[0];
          this.loader = false;
        } else {
          this.showAlertError("Failed :  " + responseData.data.message);
          this.loader = false;
        }
        console.log("DepositeChannel", responseData);
      } catch (e) {
        console.log(e);
        this.loader = false;
        this.showAlertError("Fetched data Failed: Something went wrong");
      }
    },
    submit() {
      const validate = this.$refs.form.validate();
      if (validate) {
        if (this.paymentModeData.id) {
          this.update();
        } else {
          this.save();
        }
      }
    },

    async save() {
      if (this.selectedChannel) {
        this.addDepositeChannel.channel_id = this.selectedChannel.val;
      }
      console.log(this.addDepositeChannel);
      try {
        const responseData = await partnerService.addDepositeChannel(
          this.addDepositeChannel,
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.stoploader();
          this.getAllChannels();
          this.selectedChannel = "";
        } else {
          this.showAlertError("Failed: " + responseData.data.message);
          this.loader = false;
        }
        console.log("Saved Data", responseData);
      } catch (e) {
        console.log(e);
        this.loader = false;
        this.showAlertError("Failed : Something went wrong");
      }
    },

    async update() {
      try {
        const responseData = await partnerService.updatePaymentMode(
          this.paymentModeData.id,
          this.paymentModeData,
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.formDialogVisible = false;
          this.stoploader();
          this.getAllPaymentModes();
        } else {
          this.showAlertError("Failed:" + responseData.data.message);
          this.loader = false;
        }
        console.log("Update Data", responseData);
      } catch (e) {
        console.log(e);
        this.loader = false;
        this.showAlertError("Failed : Something went wrong");
      }
    },

    deleteItem(index) {
      console.log(index);
      this.itemToDeleteIndex = index.id;
      this.dialogDelete = true;
    },

    closeDelete() {
      this.dialogDelete = false;
    },

    async deleteItemConfirm() {
      this.loader = true;
      try {
        const responseData = await partnerService.deleteDepositeChannel(
          this.itemToDeleteIndex,
        );
        this.response = responseData;
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.loader = false;
          this.getAllChannels();
          this.closeDelete();
        } else {
          this.showAlertError(responseData.data.message);
          this.loader = false;
        }
      } catch (e) {
        console.log(e);
        this.showAlertError("One or more parameter is invalid or missing!");
        this.loader = false;
      }
    },

    async isactiveupdate(item) {
      this.loader = true;
      try {
        const responseData = await partnerService.updateStatusDepositeChannel({
          id: item.id,
          is_active: item.is_active,
        });
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.stoploader();
          this.getAllPaymentModes();
        } else {
          this.showAlertError(responseData.data.message);
          this.loader = false;
        }
        console.log("respose data", responseData);
      } catch (e) {
        console.log(e);
        this.loader = false;
        this.showAlertError("Something went wrong please try again later.");
      }
    },

    // channel dropdown values
    async getChannelsByCountry(country_code) {
      this.loader = true;
      try {
        const response = await setupService.getChannelByCountry(country_code);
        if (response.data.status_code === 200) {
          this.channel_options = [
            ...response.data.data.map((i) => {
              return {
                txt: i.name,
                val: i.channel_id,
              };
            }),
          ];
          // this.addDepositeChannel.channel_id = this.channel_options[0].txt
          console.log("channel_options", this.channel_options);
          this.stoploader();
        } else {
          this.channel_options == [];
          this.stoploader();
        }
      } catch (error) {
        this.channel_options = [];
        this.stoploader();
        console.error(error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
</style>
